import type { FC } from 'react';

import { useTranslation } from 'react-i18next';

import type { SchemaCreditRequestForm } from '../../../schemas/creditRequestForm.schema';
import { DISPOSITIONSKREDIT, type DISPOSITIONSKREDIT_TYPE } from '../../../types';
import { formatIban } from '../../utils/formatIban';
import { ApplicantCell } from '../shared/ApplicantCell';
import { HideCell } from '../shared/HideCell';
import { RefinanceCell } from '../shared/RefinanceCell';
import { currencyFormat, numberFormat } from '~/lib/i18n';

type Props = {
    credit: SchemaCreditRequestForm[DISPOSITIONSKREDIT_TYPE][number];
    index: number;
    toggleRefinance: (index: number) => void;
    toggleHide: (index: number) => void;
    showDetailedView: boolean;
};

export const TableRowContent: FC<Props> = ({ credit, index, showDetailedView, toggleHide, toggleRefinance }) => {
    const { t } = useTranslation();
    return (
        <>
            <ApplicantCell
                applicant={credit.gehoertZuAntragsteller}
                source={credit.source}
                showDetailedView={showDetailedView}
            />
            <td>{t(`EXISTING_LOANS.TYPES.${DISPOSITIONSKREDIT}`)}</td>
            <td>{credit.glaeubiger ?? '---'}</td>
            <td>{credit.beanspruchterBetrag ? currencyFormat(credit.beanspruchterBetrag) : '---'}</td>
            <td>{credit.zinssatz ? `${numberFormat(credit.zinssatz)} %` : '---'}</td>
            <td>{'---'}</td>
            <td>{'---'}</td>
            <td>{'---'}</td>
            <td>{'---'}</td>
            <td>{'---'}</td>
            <td>{credit.iban ? formatIban(credit.iban) : '---'}</td>
            <RefinanceCell
                credit={credit}
                index={index}
                prefix={DISPOSITIONSKREDIT}
                creditKind={DISPOSITIONSKREDIT}
                toggleRefinance={toggleRefinance}
                showDetailedView={showDetailedView}
            />
            <HideCell credit={credit} index={index} toggleHide={toggleHide} prefix={DISPOSITIONSKREDIT} />
        </>
    );
};
